import { Component, EventEmitter, Input, OnInit, Output,  } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionService } from '../../services/permission.service';
import { ApicallService } from '../../services/apicall.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent implements OnInit {

  isShowCampaign: Boolean = false;
  isShowInvoice: Boolean = false;
  activePage: string = '/dashboard';
  activePageAgent: string = '/dashboard';
  isShowIncentives: any = false;
  isShowExport: any = false;
  isShowOrganization: boolean = false;
  isShowCompany: boolean = false;
  lockNav = false;
  agentType = this.apiCallService.user.agentType;

  constructor(
    public router: Router,
    public apiCallService: ApicallService,
    public permissionService: PermissionService
  ) {
    router.events.subscribe((val) => {
      this.activePage = this.activePageAgent = this.router.url;
      
      // if url has ln then lock navigation
      if(this.activePage.indexOf('ln') > 0) {
        this.lockNav = true;
      }
      if (
        this.activePage === '/campaigns' ||
        this.activePage === '/campaign-execution' ||
        this.activePage === '/plb-campaign' ||
        this.activePage === '/plb-campaign-execution'
      ) {
        this.isShowCampaign = true;
      } else {
        this.isShowCampaign = false;
      }
      if (
        this.activePage === '/gst-invoice-list' ||
        this.activePage === '/non-gst-invoice-list' ||
        this.activePage === '/foreign-invoice-list' ||
        this.activePage === '/configuration'
      ) {
        this.isShowInvoice = true;
      } else {
        this.isShowInvoice = false;
      }
      if (
        this.activePage === '/incentives' ||
        this.activePage === '/raised-dispute'
      ) {
        this.isShowIncentives = true;
      } else {
        this.isShowIncentives = false;
      }
      if (
        this.activePage === '/navitaire-export' ||
        this.activePage === '/import-report' ||
        this.activePage === '/ltdc-report' ||
        this.activePage === '/erp-extract'
      ) {
        this.isShowExport = true;
      } else {
        this.isShowExport = false;
      }
      if (
        this.activePage === '/unmapped-org' ||
        this.activePage === '/org-mapped' ||
        this.activePage === '/upload-mapping'
      ) {
        this.isShowOrganization = true;
      } else {
        this.isShowOrganization = false;
      }
      if (
        this.activePage === '/company-list' ||
        this.activePage === '/company-upload'
      ) {
        this.isShowCompany = true;
      } else {
        this.isShowCompany = false;
      }
    });
  }

  ngOnInit() {}

  toggleShowCampaign() {
    this.isShowCampaign = !this.isShowCampaign;
  }

  toggleShowInvoice() {
    this.isShowInvoice = !this.isShowInvoice;
  }

  toggleShowIcentives() {
    this.isShowIncentives = !this.isShowIncentives;
  }

  toggleShowExport() {
    this.isShowExport = !this.isShowExport;
  }

  toggleShowOrganization() {
    this.isShowOrganization = !this.isShowOrganization;
  }

  toggleShowCompany(){
    this.isShowCompany = !this.isShowCompany;
  }

  openCampaigns() {
    this.toggleShowCampaign();
  }

  openInvoices() {
    this.toggleShowInvoice();
  }

  openIncentives() {
    this.toggleShowIcentives();
  }

  openExport() {
    this.toggleShowExport();
  }

  openOrganization() {
    this.toggleShowOrganization();
  }

  dropDownFalse() {
    this.isShowCampaign = false;
  }

  openCompany(){
    this.toggleShowCompany();
  }
}
